import axios from './axiosConfig';
import { API_URL } from '../config';
import { QuestionStatus, DataType, Category } from '../types/enums';

export interface QuestionVersion {
    id?: number;
    question_id?: number;
    version_question: string;
    created_at?: string;
}

export interface QuestionVersionInput {
    version_question: string;
}

export interface QuestionData {
    question: string;
    level: number;
    status: QuestionStatus;
    category: Category;
    vector_db_data?: string;
    data_type: DataType;
    additional_info?: string;
    versions: QuestionVersionInput[];
}

export interface QuestionFilters {
    level?: number;
    status?: string;
    category?: string;
    question?: string;
}

export interface PaginationParams {
    page: number;
    size: number;
    sort_by?: string;
    sort_order?: 'asc' | 'desc';
}

export const QuestionService = {
    getAllQuestions: async (questionFilters: QuestionFilters, paginationParams: PaginationParams) => {
        try {
            console.log(questionFilters)
            const response = await axios.post(`${API_URL}/v1/questions/with-versions/filters`, {
                filters: questionFilters,
                pagination: paginationParams
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching questions:', error);
            throw error;
        }
    },

    getQuestionById: async (id: number) => {
        try {
            const response = await axios.get(`${API_URL}/v1/question/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching question:', error);
            throw error;
        }
    },

    getQuestionsWithVersions: async (params: {
        page: number;
        size: number;
        sort_by?: string;
        sort_order?: 'asc' | 'desc';
        filters?: QuestionFilters;
    }) => {
        try {
            const response = await axios.post(`${API_URL}/v1/questions/with-versions`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching questions with versions:', error);
            throw error;
        }
    },

    getQuestionsWithFilters: async (filters: QuestionFilters, params: {
        page: number;
        size: number;
        sort_by?: string;
        sort_order?: 'asc' | 'desc';
    }) => {
        try {
            const response = await axios.post(`${API_URL}/v1/questions/filter`, {
                filters,
                pagination: params
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching questions with filters:', error);
            throw error;
        }
    },

    createQuestion: async (questionData: QuestionData) => {
        try {
            console.log(questionData)
            const response = await axios.post(`${API_URL}/v1/question`, questionData);
            return response.data;
        } catch (error) {
            console.error('Error creating question:', error);
            throw error;
        }
    },

    updateQuestion: async (id: number, questionData: QuestionData) => {
        try {
            console.log(questionData)
            const response = await axios.put(`${API_URL}/v1/question/${id}`, questionData);
            return response.data;
        } catch (error) {
            console.error('Error updating question:', error);
            throw error;
        }
    },

    deleteQuestion: async (id: number) => {
        try {
            await axios.delete(`${API_URL}/v1/questions/${id}`);
        } catch (error) {
            console.error('Error deleting question:', error);
            throw error;
        }
    },

    createQuestionVersion: async (questionId: number, versionData: QuestionVersion) => {
        try {
            const response = await axios.post(`${API_URL}/v1/questions/${questionId}/versions`, versionData);
            return response.data;
        } catch (error) {
            console.error('Error creating question version:', error);
            throw error;
        }
    },

    updateQuestionVersion: async (questionId: number, versionId: number, versionData: QuestionVersion) => {
        try {
            const response = await axios.put(`${API_URL}/v1/questions/${questionId}/versions/${versionId}`, versionData);
            return response.data;
        } catch (error) {
            console.error('Error updating question version:', error);
            throw error;
        }
    },

    deleteQuestionVersion: async (id: number) => {
        try {
            await axios.delete(`${API_URL}/v1/versions/${id}`);
        } catch (error) {
            console.error('Error deleting question version:', error);
            throw error;
        }
    },
    createVersion: async (questionId: number, version: string) => {
        try {
            const response = await axios.post(`${API_URL}/v1/questions/${questionId}/versions`, version);
            return response.data;
        } catch (error) {
            console.error('Error creating version:', error);
            throw error;
        }
    }
};
